import { TagERP, TagType } from "@finanedi.es/storybook"
import {
  faCircleCheck,
  faCircleXmark,
  faClock,
} from "@fortawesome/pro-light-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { ESTADO_ACTIVO, EstadoActivoType } from "api/Types/EstadoActivo"
import { TFunction } from "i18next"

export const estadoActivosVariants = (
  t: TFunction
): Record<
  EstadoActivoType,
  {
    icon: React.ReactNode
    color: TagType
    label: string
  }
> => ({
  [ESTADO_ACTIVO.PENDIENTE]: {
    icon: <FontAwesomeIcon icon={faClock} />,
    label: t("nsAssets.filters.status.pending"),
    color: "alternativeOne",
  },
  [ESTADO_ACTIVO.ACTIVO]: {
    icon: <FontAwesomeIcon icon={faCircleCheck} />,
    label: t("nsAssets.filters.status.active"),
    color: "success",
  },
  [ESTADO_ACTIVO.VENDIDO]: {
    icon: <FontAwesomeIcon icon={faCircleCheck} />,
    label: t("nsAssets.filters.status.amortized"),
    color: "primary",
  },
  [ESTADO_ACTIVO.AMORTIZADO]: {
    icon: <FontAwesomeIcon icon={faCircleCheck} />,
    label: t("nsAssets.filters.status.amortized"),
    color: "info",
  },
  [ESTADO_ACTIVO.DADO_DE_BAJA]: {
    icon: <FontAwesomeIcon icon={faCircleXmark} />,
    label: t("nsAssets.filters.status.withdrawn"),
    color: "danger",
  },
})

export const EstadoActivos = ({
  variant,
  t,
}: {
  variant?: EstadoActivoType
  t: TFunction
}): JSX.Element => {
  const { label, color, icon } =
    estadoActivosVariants(t)[variant ?? ESTADO_ACTIVO.PENDIENTE]

  return (
    <TagERP
      value={label}
      color={color}
      icon={icon}
    />
  )
}
